import {
  Container
} from '@mui/material';
import { useEffect, useState } from 'react';
// redux
import Page from 'src/components/Page';
// components
import { nomeProjeto } from 'src/config';
import useAuth from 'src/hooks/useAuth';

import { HeaderPageComponentConfig } from 'src/components/_dashboard/configuracoes';
import Iconify from 'src/components/Iconify';
import Table from './TableDirecionamentos';
import { CardContent, Card } from 'src/@/components/ui/card';
import ModalDirecionamentos from './ModalDirecionamentos';

import { Button } from 'src/@/components/ui/button';

///
import v2_actionListaTagsChats from 'src/actions/v2/chats/v2_actionListaTagsChats';
import v2_actionCriarTag from 'src/actions/v2/chats/v2_actionCriarTag';
import v2_actionEditarTag from 'src/actions/v2/chats/v2_actionEditarTag';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import v2_actionDeletarTag from 'src/actions/v2/chats/v2_actionDeletarTag';
import v2_actionListaFluxosDiretos from 'src/actions/v2/cliente/v2_actionListaFluxosDiretos';
import { useDispatch, useSelector } from 'react-redux';
import { getListaUsuariosTransferencia, getListaSetoresTransferencia } from 'src/redux/slices/user';
import v2_actionEditarDirecionamentoDireto from 'src/actions/v2/cliente/v2_actionEditarDirecionamentoDireto';
import v2_actionDeleteFlowDirect from 'src/actions/v2/cliente/v2_actionDeleteFlowDirect';
import { ScrollArea } from 'src/@/components/ui/scroll-area';
import TableSkeleton from 'src/components/skeleton/TableSkeleton';
import v2_actionCriarDirecionamento from 'src/actions/v2/cliente/v2_actionCriarDirecionamento';

// ----------------------------------------------------------------------
const TABLE_HEAD = [
  { id: 'nome', label: 'Nome', alignRight: false },
  { id: 'data', label: 'Data Criação', alignRight: false },
  { id: '' },
];
// ----------------------------------------------------------------------

export default function DirecionamentosComponent() {
  const { user } = useAuth();
  const dispatch = useDispatch();

  const [openDialogNovoSetor, setOpenDialogNovoSetor] = useState(false);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const [action, setAction] = useState('');
  const { listaUsuariosTransferencia, listaSetoresTransferencia } = useSelector((state) => state.user);
  ///// value fields
  const [direcionamentoId, setDirecionamentoId] = useState('');
  const [fluxos, setFluxos] = useState([]);
  const [recebe, setRecebe] = useState('');
  const [usersSelect, setUsersSelect] = useState([]);
  const [departamentSelect, setDepartamentSelect] = useState([]);
  const [sendMessage, setSendMessage] = useState(false);

  const [dataMessage, setDataMessage] = useState({
    chatFiles:[],
    chatText: '',
    chatTypeMessage: 'text',
  });


  async function getList() {
    try {
      const response = await v2_actionListaFluxosDiretos(user.clienteId);
      setFluxos(response.data.data)
    } catch (error) {
      console.log(error);
    }

  }

  useEffect(() => {
    getList();
    dispatch(getListaUsuariosTransferencia(user.clienteId))
    dispatch(getListaSetoresTransferencia(user.clienteId))

  }, []);


  function applyFilter(tableData, filterName) {
    if (filterName) {
      tableData = tableData.filter(
        (item) =>
          item.nome.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
      );
    }
    return tableData;
  }

  async function handleCriarDirecionamento() {
    try {
      setLoading(true)
      const data = {
        scope: {
          direcionaUsuarios: usersSelect,
          direcionaSetores: departamentSelect,
          recebe: recebe
        }
      }
      setLoadingCreate(true)
      await v2_actionCriarDirecionamento(user.clienteId, data);
      await getList();
      setLoading(false)
      setOpenDialogNovoSetor(false);
      setRecebe('');
      setUsersSelect([]);
      setDepartamentSelect([]);
      setLoadingCreate(false)
    } catch (error) {
      setLoading(false)
      setLoadingCreate(false)
    }
  }

  async function handleDeletarTag() {
    try {
      await v2_actionDeleteFlowDirect(direcionamentoId);
      await getList();
      setRecebe('');
      setDirecionamentoId('');
      setOpenModalConfirmacao(false);
    } catch (error) {

    }
  }

  const handleEditarTag = async () => {
    try {
      let data = {
        scope: {
          direciona_usuarios: usersSelect,
          direciona_setores: departamentSelect,
          recebe: recebe
        }
      }
      setLoadingCreate(true)
      await v2_actionEditarDirecionamentoDireto(direcionamentoId, data);
      await getList();
      setAction('');
      setRecebe('');
      setUsersSelect([]);
      setDepartamentSelect([]);
      setDirecionamentoId('');
      setOpenDialogNovoSetor(false);
      setLoadingCreate(false)
    } catch (error) {
      setLoadingCreate(false)
      console.log('error', error)
    }

  };


  const dataFiltered = applyFilter(fluxos, pesquisa);

  return (
    <Page title={`${nomeProjeto} - Direcionamentos`}>

      <Container fullWidth maxWidth={"lg"}  >
        <HeaderPageComponentConfig
          titulo="Direcionamentos"
          descricao={'Crie direcionamento para setores e usuários'}
          actions={<Button
            onClick={() => {
              setOpenDialogNovoSetor(true);
              setAction('Criar')
            }}
          >
            Criar Direcionamento
          </Button>}
        />

        <ModalConfimacao
          open={openModalConfirmacao}
          onClose={() => {
            setOpenModalConfirmacao(false);
          }}
          onConfirm={handleDeletarTag}
          loadingFinalizar={loading}
          mensagem={'Deseja mesmo excluir essa etiqueta?'}
        />

        <ModalDirecionamentos
          users={listaUsuariosTransferencia}
          departaments={listaSetoresTransferencia}
          usersSelect={usersSelect}
          departamentSelect={departamentSelect}
          loadingCreate={loadingCreate}
          changeDepartament={(e) => {
            setDepartamentSelect(e)

          }}
          changeUser={(e) => {
            setUsersSelect(e)
          }}
          open={openDialogNovoSetor}
          action={action}
          recebe={recebe}
          changeRecebe={(e) => {
            setRecebe(e.target.value)
          }}
          onSubmit={action === "Criar" ? handleCriarDirecionamento : handleEditarTag}
          onClose={() => {
            setOpenDialogNovoSetor(false);
            setRecebe('');
            setDirecionamentoId('');
            setUsersSelect([]);
            setDepartamentSelect([]);
          }}
          sendMessage={sendMessage}
          changeSendMessage={(e) => {
        
            setSendMessage(e)
          }}
          data={dataMessage}
          changeBlock={(e) => {
            const { name, value } = e;
            console.log('name', e)
            if(name === "chatTypeMessage") {
              setDataMessage({
                ...dataMessage,
                chatTypeMessage: value
              })
            } else if(name === "chatText") {
              setDataMessage({
                ...dataMessage,
                chatText: value
              })
              
            } else if(name === "chatFiles") {
              setDataMessage({
                ...dataMessage,
                chatFiles: value
              })
            }
          }}
        />

        <Card className="mt-8">
          <ScrollArea className="h-[75vh]">
          <CardContent>
            {loading ? 
             <TableSkeleton />
             : 
             <Table
              data={dataFiltered}
              onDelete={row => {
                setDirecionamentoId(row._id);
                setOpenModalConfirmacao(true);
              }}
              onEdit={row => {
                setOpenDialogNovoSetor(true)
                setDepartamentSelect(row.direciona_setores);
                setUsersSelect(row.direciona_usuarios);
                setAction('Editar')
                setDirecionamentoId(row._id);
                setRecebe(row.recebe);
              }}
            />
          }
            
          </CardContent>
          </ScrollArea>
        </Card>
      </Container>
    </Page>
  );
}
